import React, {useState} from "react"
import {
    Card,
    CardBody,
    Container,
    Nav,
    NavItem, NavLink,
} from "reactstrap"
import PropTypes from "prop-types"
import "react-toastify/dist/ReactToastify.css"
import classnames from "classnames";
import ImportationEtudiant from "./ImportationEtudiant";
const ImportationEtudiantSem = props => {
    const [section, setSection] = useState("")
    const [semestre, setSemestre] = useState([

        {value: 3, label: "Session Contrôle semestre 1", section: 0},
        {value: 4, label: "Session Contrôle semestre 2", section: 1},
    ])
    const renderBlock = section => {
        for (let i = 0; i < semestre.length; i++) {
            if (section === i) {
                return <ImportationEtudiant semestre={semestre[i]}/>
            }
        }
    }
    return (
        <React.Fragment>

            <Container fluid>
                <Card>
                    <CardBody>
                        <Nav className="icon-tab nav-justified">
                            {semestre.map((element, index) => (
                                <NavItem key={index}>
                                    <NavLink
                                        style={{cursor: "pointer"}}
                                        className={classnames({
                                            active: section === element.section,
                                        })}
                                        onClick={() => {
                                            setSection(element.section)
                                        }}
                                    >
                                        <span className="d-none d-sm-block">{element.label}</span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                        {renderBlock(section)}
                    </CardBody>
                </Card>
            </Container>

        </React.Fragment>
    )
}

export default ImportationEtudiantSem
ImportationEtudiantSem.propTypes = {
    history: PropTypes.object,
    back: PropTypes.object,
    setSection: PropTypes.object,
}
